module.exports = __webpack_public_path__ + "img/exe.2277dc01.svg";